<template>
  <tr v-if="rate">
    <td>{{ charge?.label }}</td>
    <td></td>
    <td>
      <currency-input
        :name="`rates[${rate.charge_id.toString()}][rate]`"
        v-model="rate.rate"
      ></currency-input>
    </td>
    <td>
      <currency-input
        :name="`rates[${rate.charge_id.toString()}][commercial_rate]`"
        v-model="rate.commercial_rate"
      ></currency-input>
    </td>
    <td>
      <currency-input
        :name="`rates[${rate.charge_id.toString()}][max_rate]`"
        v-model="rate.max_rate"
      ></currency-input>
    </td>
    <td>
      <select
        name="charge_type_id"
        class="form-control"
        v-model="rate.charge_type_id"
      >
        <option value="" disabled readonly>
          Please Select
        </option>
        <option
          :value="type.id"
          :key="index"
          v-for="(type, index) in chargeTypes"
        >
          {{ type.label }}
        </option>
      </select>
    </td>
  </tr>
</template>
<script>
import CurrencyInput from '@/components/Generic/Form/CurrencyInput';

export default {
  props: {
    rates: {
      type: Array,
      required: true
    },
    charge: {
      type: Object,
      required: true
    },
    tariff: {
      type: Object,
      required: false
    },
    commercialTariff: {
      type: Object,
      required: true
    },
    selectedTariff: {
      type: Object,
      required: false,
      default: () => ({})
    },
    group: {
      type: [String, Number],
      required: false
    }
  },

  components: {
    CurrencyInput
  },

  computed: {
    commercialRate() {
      const tariffRate = this.commercialTariff?.rates?.find(rate => {
        if (rate.charge_id != this.charge?.id) {
          return false;
        }

        if (rate.group_id && rate.group_id != this.group) {
          return false;
        }

        if (rate.abi_group_id && rate.abi_group_id != this.group) {
          return false;
        }

        return true;
      });

      return tariffRate?.rate || 0;
    },

    chargeTypes() {
      return this.$store.getters['CreditHireChargeTypes/all'];
    },

    oneOffFee() {
      return this.chargeTypes.find(type => type.name === 'one_off_fee');
    }
  },

  data() {
    return {
      rate: undefined
    };
  },

  mounted() {
    this.setRate();
  },

  methods: {
    setRate() {
      let rate = this.rates.find(r => r.charge_id === this.charge.id);

      if (!rate) {
        const tariffRate = (Object.keys(this.selectedTariff).length
          ? this.selectedTariff
          : this.tariff
        )?.rates.find(r => {
          if (r.charge_id === this.charge.id) {
            if (!this.group || this.group == this.charge.group_id) {
              return true;
            }
          }

          return false;
        });

        const index = this.rates.push({
          charge_id: this.charge.id,
          charge_type_id: tariffRate?.charge_type_id || this.oneOffFee?.id,
          rate: tariffRate?.rate,
          commercial_rate: this.commercialRate,
          max_rate: tariffRate?.max_rate || null
        });

        rate = this.rates[index - 1];
      }

      this.rate = rate;
    },

    updateFromTariff() {
      const selectedTariff = Object.keys(this.selectedTariff).length
        ? this.selectedTariff
        : this.tariff;
      if (selectedTariff && this.group) {
        const tariffRate = this.tariff.rates.find(rate => {
          if (rate.group_id) {
            return (
              rate.group_id &&
              rate.group_id == this.group &&
              rate.charge_id == this.charge.id
            );
          }

          return (
            rate.abi_group_id &&
            rate.abi_group_id == this.group &&
            rate.charge_id == this.charge.id
          );
        });

        if (tariffRate) {
          const index = this.rates.findIndex(
            rate => rate.charge_id === this.charge.id
          );

          if (index > -1) {
            this.rates[index].rate = tariffRate.rate;
            this.rates[index].commercial_rate = this.commercialRate;
            this.rates[index].max_rate = tariffRate.max_rate;
            this.rates[index].charge_type_id = tariffRate.charge_type_id;
          } else {
            const index = this.rates.push({
              charge_id: this.charge.id,
              charge_type_id: tariffRate.charge_type_id,
              rate: tariffRate.rate,
              commercial_rate: this.commercialRate,
              max_rate: tariffRate.max_rate || null
            });

            this.rate = this.rates[index - 1];
          }
        }
      }
    }
  },

  watch: {
    group() {
      this.updateFromTariff();
    },

    tariff() {
      this.updateFromTariff();
    }
  }
};
</script>
